import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import helper from '../helpers';
import closeIcon from '../../../assets/images/x_icon_black.svg';
import editIcon from '../../../assets/images/edit.svg';
import saveIcon from '../../../assets/images/check-mark-black.svg';

import './index.scss';

const getPhoneNumber = (contacts, selectedConversation) => {
  const phoneDetails = contacts.find((contact) => contact.type === 'PHONE');
  const alternate = contacts.filter((contact) => {
    if (
      contact.type === 'PHONE' &&
      selectedConversation?.userPhone?.replace('+1', '') !==
      contact?.value?.replace('+1', '')
    ) {
      return contact?.value?.trim();
    }
  });
  if (alternate.length > 0) {
    return helper.formatPhoneNumber(alternate[0].value) || '';
  } else {
    return '';
  }
};

const getEmail = (contacts) => {
  const emailDetails = contacts.find((contact) => contact.type === 'EMAIL');
  if (emailDetails) {
    return emailDetails.value;
  } else {
    return '';
  }
};

const ProfileInfo = ({
  details,
  selectedConversation,
  showPaymntinfo,
  editCallerName,
}) => {
  const [name, setCallerName] = useState(details.name);
  const [nameError, serError] = useState(false);
  const [namefieldReadonly, setnamefieldReadonly] = useState(true);
  useEffect(() => {
    setCallerName(details.name);
  }, [details.name]);

  const onCallerNameChange = (event) => {
    let inputValue = event?.target?.value || '';
    let sanitizedValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '').trimStart();
    if (sanitizedValue === '' && inputValue !== '') {
      return;
    }
    serError(sanitizedValue.length === 0);
    setCallerName(sanitizedValue);
  };

  const editName = (name) => {
    console.log(name);
    setnamefieldReadonly(false);
  };

  const saveName = () => {
    setnamefieldReadonly(true);
    if (name.length > 1) {
      editCallerName(name, details.bzId, details.id, selectedConversation.userId);
    } else {
      serError(true);
    }
  };

  return (
    <div className="client-profile__card">
      <h1 className="client-profile__card__heading">Profile info</h1>
      <div className="client-profile__card__content">
        <ul>
          {details && details.name ? (
            <li>
              <div className="name-editable">
                <span className="client-profile__card__content__list-head">
                  Name:
                </span>
                <input
                  className={classNames(
                    'client-profile__card__content__list-textinput',
                    { 'read-write': !namefieldReadonly },
                  )}
                  type="text"
                  value={name}
                  onChange={onCallerNameChange}
                  disabled={namefieldReadonly}
                />
                <div className="icon-list">
                  {namefieldReadonly ? (
                    <>
                      <img
                        className="edit-icon"
                        src={editIcon}
                        onClick={() => editName(name)}
                        data-multiline={true}
                        data-place='bottom'
                        html={true}
                        data-tip='Note : Updated name will reflect in the booking software as well.'
                      />
                      <ReactTooltip />
                    </>
                  ) : (
                    <>
                      <img
                        className="save-icon"
                        onClick={() => saveName()}
                        src={saveIcon}
                      />{' '}
                      <img
                        className="close-icon"
                        onClick={() => setCallerName('')}
                        src={closeIcon}
                      />
                    </>
                  )}
                </div>
              </div>
              {nameError && <div className="error-message">Please enter valid name</div>}
            </li>
          ) : null}
          {details &&
            details.contacts &&
            getPhoneNumber(details.contacts, selectedConversation) ? (
              <li className="alternate-number">
                <span className="client-profile__card__content__list-head">
                  Alternate phone number:
                </span>
                <span className="client-profile__card__content__list-text">
                  {getPhoneNumber(details.contacts, selectedConversation)}
                </span>
              </li>
            ) : null}

          {details && details.contacts && getEmail(details.contacts) ? (
            <li>
              <span className="client-profile__card__content__list-head">
                Email:{' '}
              </span>
              <span className="client-profile__card__content__list-text">
                {getEmail(details.contacts)}
              </span>
            </li>
          ) : null}
          {showPaymntinfo ? (
            <li>
              <span className="client-profile__card__content__list-head">
                Payment info on file:
              </span>
              <span className="client-profile__card__content__list-text">
                {details.credit_card && details.credit_card.card_type
                  ? `${details.credit_card.card_type}` +
                  ' ' +
                  (details.credit_card.last4 ? details.credit_card.last4 : '')
                  : 'Not available'}
              </span>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

export default ProfileInfo;
